import { GAME_ID, REDUX_ACTIONS } from '../../data/constants';
import { getLevelItems } from '../../content/curriculum';

export const initialState = {
  roundNumber: 0,
  currentQuestion: {},
  selectedTile: null,
  questionIsSimplified: false,
};

const onboardingReducer = (state = initialState, action) => {
  if (action.gameId !== GAME_ID) {
    return state;
  }

  switch (action.type) {
    case REDUX_ACTIONS.INIT_ONBOARDING:
      return {
        ...initialState,
        currentQuestion: getLevelItems(0)[0],
      };
    case REDUX_ACTIONS.SIMPLIFY_ONBOARDING_QUESTION:
      return {
        ...state,
        questionIsSimplified: true,
        selectedTile: null,
      };
    case REDUX_ACTIONS.SELECT_ONBOARDING_TILE:
      return {
        ...state,
        selectedTile: action.payload.selectedTile,
      };
    default:
      return state;
  }
};

export default onboardingReducer;
